import axiosInstance from "./AxiosInstance";

export function getTemplateList(data) {
    return axiosInstance.post(`template/list`, data);
}

export function UploadEditorImage(formData) {
    return axiosInstance.post(`template/upload-editor-image`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function TemplateQuestionList(data) {
    return axiosInstance.post(`template/question-list`, { template_uuid: data.template_uuid });
}

export function GeneratePDF(data) {
    return axiosInstance.post(`template/generate-pdf`, data, {
        responseType: 'blob'
    });
}

export function SaveTemplate(data) {
    return axiosInstance.post(`template/save`, data, {
        responseType: 'blob'
    });
}


export function createTemplateFolder(data) {
    return axiosInstance.post(`template/folder/create`, data);
}

export function editTemplateFolder(data) {
    return axiosInstance.post(`template/folder/edit`, data);
}

export function deleteTemplateFolder(data) {
    return axiosInstance.post(`template/folder/delete`, data);
}

export function templateFolderList(data) {
    return axiosInstance.post(`template/folder/list`, data);
}

export function moveTemplateFolder(data) {
    return axiosInstance.post(`template/folder/move`, data);
}

export function renameEnvelopeTemplate(data) {
    return axiosInstance.post(`template/envelope/rename`, data);
}

export function deleteEnvelopeTemplate(data) {
    return axiosInstance.post(`template/envelope/delete`, data);
}

export function moveEnvelopeTemplate(data) {
    return axiosInstance.post(`template/envelope/move`, data);
}

export function templateFolderBreadcrumbs(data) {
    return axiosInstance.post(`template/folder/breadcrumbs`, data);
}

export function getTemplateEnvelope(data) {
    return axiosInstance.post(`template/envelope/detail`, data);
}

export function templateEnvelopeModify(data) {
    let config = {
        headers:{
            "content-type": "multipart/form-data",
        }
    };
    return axiosInstance.post(`template/envelope/modify`, data, config);
}

export function copyTemplateEnvelope(data) {
    return axiosInstance.post(`template/envelope/copy`, data);
}

export function templateUseForEnvelope(data) {
    return axiosInstance.post(`/use-template`, data);
}

export function getTemplateUser(data) {
    return axiosInstance.post(`template/users-list`, data);
}

export function shareTemplateFolder(data) {
    return axiosInstance.post(`template/share`, data);
}

export function removeShareTemplateFolder(data) {
    return axiosInstance.post(`template/share/remove`, data);
}

export function TemplateList(data) {
    return axiosInstance.post(`template/lists`, data);
}

export function TemplateDetail(data) {
    return axiosInstance.post(`template/form`, data);
}

export function TemplateStart(data) {
    return axiosInstance.post(`template/start`, data);
}

export function QuestionSave(data) {
    return axiosInstance.post(`template/save`, data);
}

export function SubmitForm(data) {
    return axiosInstance.post(`template/submit`, data);
}
export const GenerateContract = async (data, config = {}) => {
    return axiosInstance.post(`template/generate-contract`, data, {
      ...config,
      headers: {
        'Content-Type': 'application/json',
        ...config.headers
      }
    });
  };




  // Negotiation APIs
export function getNegotiationList(data) {
    return axiosInstance.post(`negotiation/list`, data);
}

export function createNegotiation(data) {
    return axiosInstance.post(`negotiation/create`, data);
}

export function selectNegotiationTemplate(data) {
    return axiosInstance.post(`negotiation/select-template`, data);
}

export function fillNegotiationQuestionnaire(data) {
    return axiosInstance.post(`negotiation/fill-questionnaire`, data);
}

export function saveNegotiationDraft(data) {
    return axiosInstance.post(`negotiation/save-draft`, data);
}

export function addNegotiationRecipient(data) {
    return axiosInstance.post(`negotiation/add-recipient`, data);
}

export function sendNegotiation(data) {
    return axiosInstance.post(`negotiation/send`, data);
}

// Customer side
export function getCustomerNegotiationDetail(data) {
    return axiosInstance.post(`customer/negotiation/detail`, data);
}

